<div class="container clickable" (click)="viewModel.click()">
    <div class="radiobutton {{radioClass | async}}"></div>
    <p class="label {{labelClass | async}}">{{viewModel.onGetLabel | async}}</p>
</div>